import Tool from '@/models/tool'

export default class Toolkit {
  constructor(tools) {
    // TODO: Type check that param is an map of Tool objects.
    this.tools = tools
  }

  static convert(object) {
    let result = new Map()
    for (const [key, tool] of Object.entries(object)) {
      result.set(tool.id, new Tool(
        tool.id,
        key,
        tool.name,
        tool.description,
        tool.category,
        tool.unlocked_date,
        tool.state
      ))
    }
    return new Toolkit(result)
  }
}